import React from 'react';
import {Script} from 'gatsby-script';
import {validateJSONStructuredData} from '../utils/validateJSONStructuredData';

type StructuredData = {
  jsonString: string;
  dataTestId?: string;
};

export const StructuredData: React.FC<StructuredData> = ({jsonString, dataTestId}) => {
  if (!jsonString) {
    return null;
  }

  validateJSONStructuredData(jsonString);

  return <Script type='application/ld+json' dangerouslySetInnerHTML={{__html: jsonString}} data-testid={dataTestId}></Script>;
};
